import Icon from '@material-ui/icons/BugReport';
import React from 'react';
import { CreateButton } from '../../../../buttons';
import { EditDialog } from '../../../../controllers';
import { NumberInput, ReferenceInput } from '../../../../inputs';

export default {
  Icon,
  menuItems: [
  ],
  dialogs: {
    create: props => (
      <CreateButton
        fixedValue={{ badge_condition_id: props.parentResource.id }}
        {...props}
      >
        <ReferenceInput
          source="curriculum_activity_id"
          required
        />
        <NumberInput
          source="count"
          required
        />
      </CreateButton>
    ),
    edit: props => (
      <EditDialog
        {...props}
      >
        <NumberInput
          source="count"
          required
        />
      </EditDialog>
    ),
  },
  routes: {
  },
  components: {
  },
  resources: {
  },
};
